import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import FooterPrice from "./FooterPrice";
import PaymentButton from "./PaymentButton";
import StepLink from "./StepLink";

export default function FooterNavigation() {
  const {
    currentStep,
    strings,
    steps,
  } = useContext(CarOrderingContext)

  const nextStep = steps.find(step => step.id > currentStep.id)

  return (
    <div className='config-overview-bar__buttons-wrapper'>
      <FooterPrice/>

      {currentStep?.isCheckout ? (
        <div className='config-overview-bar__buttons'>
          <PaymentButton/>
        </div>
      ) : (
        <StepLink step={nextStep} label={strings.navigation.next} htmlId={'next-' + currentStep.id}/>
      )}
    </div>
  )
}
